import { useEffect, useState } from "react";
import Icon1 from "../icons/Icon";

export default function ExtractionLoading({ delay }) {
  const [secondsPassed, setSecondsPassed] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsPassed((prev) => prev + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <>
        <div
          onClick={() => {}}
          className=" fixed top-0 left-0 h-screen w-screen bg-black flex flex-col justify-center gap-4  items-center   "
        >
          {" "}
          <Icon1 icon_name="stars" size={20} fill="white"></Icon1>
          <div className=" min-w-20 flex flex-row gap-4 text-wshadow_80 font-medium text-h2  rounded-xl ">
            Extraction en cours ...
          </div>
          <div className=" w-c400 h-1 bg-wshadow_25 rounded-xl relative">
            <div
              className="absolute top-0 left-0 h-full rounded-l-xl bg-gradient-to-r from-pink-400 to-cyan-300
                animate-progress-bar transition-all duration-1000 ease-linear
                "
              style={{
                width: `${((secondsPassed % delay) / delay) * 100}%`,
              }}
            ></div>
          </div>{" "}
          <div className="  text-wshadow_50  text-h3">{secondsPassed}s</div>
        </div>
      </>
    </div>
  );
}
